import { BehaviorSubject, Observable } from 'rxjs';
import { EditingMessage, MessageViewModel, QuotedMessage, UnreadSeparatorState } from '../interfaces';

export class MessageContextStorage {
  private readonly quotedMessageSubject: BehaviorSubject<QuotedMessage | null> =
    new BehaviorSubject<QuotedMessage | null>(null);

  private readonly editingMessageSubject: BehaviorSubject<EditingMessage | null> =
    new BehaviorSubject<EditingMessage | null>(null);

  private readonly unreadSeparatorSubject: BehaviorSubject<UnreadSeparatorState | null> =
    new BehaviorSubject<UnreadSeparatorState | null>(null);

  readonly quotedMessage$: Observable<QuotedMessage | null> = this.quotedMessageSubject.asObservable();
  readonly editingMessage$: Observable<EditingMessage | null> = this.editingMessageSubject.asObservable();

  setQuotedMessage(message: MessageViewModel): void {
    this.clearEditingMessage();
    this.quotedMessageSubject.next({
      id: message.id,
      text: message.text,
      userName: message.userName,
      imageUrl: message.imageUrls?.[0] || null
    });
  }

  clearQuotedMessage(): void {
    this.quotedMessageSubject.next(null);
  }

  setEditingMessage(message: MessageViewModel): void {
    this.clearQuotedMessage();
    this.editingMessageSubject.next({
      id: message.id,
      text: message.text
    });
  }

  clearEditingMessage(): void {
    this.editingMessageSubject.next(null);
  }

  setUnreadSeparatorState(lastReadMessageId: string, unreadCount: number): void {
    this.unreadSeparatorSubject.next({ lastReadMessageId, unreadCount });
  }

  getUnreadSeparatorState(): UnreadSeparatorState | null {
    const state: UnreadSeparatorState | null = this.unreadSeparatorSubject.getValue();
    if (state) {
      this.unreadSeparatorSubject.next(null);
    }
    return state;
  }

  clearUnreadSeparatorState(): void {
    this.unreadSeparatorSubject.next(null);
  }

  clearAll(): void {
    this.clearQuotedMessage();
    this.clearEditingMessage();
    this.clearUnreadSeparatorState();
  }
}
